import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSurprise } from '@fortawesome/free-regular-svg-icons';

export default function EmptyList() {
    return (
        <div className="col nav justify-content-center mt-4 mb-4" >
            <FontAwesomeIcon className="mr-2 " size="lg" icon={faSurprise} />
            <span>No hay elementos para mostrar</span>
        </div>
    );
}